import styled from 'styled-components';

const DatePickerWrapper = styled.div`
  margin-right: 47px;
`;

export default DatePickerWrapper;
